<template>
  <div>
    <el-row>
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20">
        <div class="title">
          <h1>VR数字孪生</h1>
        </div>
        <div class="video">
          <div class="">
            <video controls="" muted="" src="../assets/502sim.mp4">
              我的天啊！我的视频在哪里？
            </video>
          </div>
        </div>
        <div class="abstract">
          在浙江大学则通楼工作的时候，我随手搭建了一个VR办公室，可以抓取电脑屏幕，以VR方式显示在电脑上，桌子和房间的建模和贴图都是我自己做的。
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>
    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20">
        <div class="sub-title">衍生作品：我家的数字孪生</div>
        <div class="text">
          我还为我的房子制作了一个数字孪生。不得不说，这完全是一个浩大的工程，因为我不是学建筑的。但整个房子还是我自己用从房地产开发商那里借来的工程图纸来建模的。我已尽最大努力恢复房子的内部结构、外部特征和内部。当我在真实的房子里通过 VR 观察这个数字房子时，感觉很奇怪，但又很神奇。就好像平行时空真的存在一样。
          <br /><br />
          当我把这个数字孪生交给住在这个房子里的父母玩时，他们最喜欢的操作就是直接从二楼或三楼的阳台转移到一楼的地面。这种打破社会规则或生理限制的操作可以给他们带来巨大的快乐。
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>
    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20">
        <div class="picture">
          <img src="../assets/project2_2.png.webp" />
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Project2Zh",
};
</script>

<style scoped>
.picture img {
  width: 100%;
}
.sub-title {
  margin-bottom: 20px;
  font-size: 15px;
  color: #666;
  font-weight: 400;
  text-align: justify;
}
.text {
  font-size: 15px;
  color: #333;
  font-weight: 100;
  text-align: justify;
}
.abstract {
  margin-top: 40px;
  font-size: 15px;
  color: #333;
  font-weight: 100;
  text-align: justify;
}
video {
  width: 100%;
}
.grid-content {
  min-height: 36px;
}
.video {
  margin-top: 100px;
}
.picture {
  margin-top: 0;
}
.title {
  margin-top: 100px;
  text-align: center;
}
.title a {
  color: #333;
}
.title p {
  color: #aaa;
  line-height: 30px;
}
.title h1 {
  font-size: 30px;
  font-weight: 100;
  letter-spacing: 6px;
  color: #333333;
}
</style>
